import '../appComponents/desktop/css/DesktopModalStyles.css';
import React, { Component } from 'react';
import PlatformLanguageButton from '../appComponents/mobile/PlatformLanguageButton';
import { Auth } from 'aws-amplify';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import './css/WelcomeExperience.css';

const LOGO = 'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png';
const ABOUT_URL = 'https://lenderblockcorp.com/blenderplatform';

const copy = {
  english: {
    languageSwitch: 'Español',
    eyebrow: 'THE BLENDER PLATFORM',
    heroFirst: 'A new way to',
    heroAccent: 'move forward.',
    heroDescription: 'Lend, borrow, and stake through one connected, blockchain-powered credit platform.',
    heroLink: 'Explore the platform',
    featureOne: 'Lend',
    featureOneDescription: 'Put available capital to work.',
    featureTwo: 'Borrow',
    featureTwoDescription: 'Access collateral-backed credit.',
    featureThree: 'Stake',
    featureThreeDescription: 'Support credit opportunities.',
    cardEyebrow: 'YOUR ACCOUNT',
    welcome: 'Welcome back',
    welcomeDescription: 'Sign in to continue to your Blender dashboard.',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Enter your username',
    passwordPlaceholder: 'Enter your password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    show: 'Show',
    hide: 'Hide',
    forgot: 'Forgot password?',
    login: 'Sign in',
    loggingIn: 'Signing in…',
    newHere: 'New to The Blender Platform?',
    createAccount: 'Create an account',
    resetEyebrow: 'ACCOUNT RECOVERY',
    resetTitle: 'Reset your password',
    resetDescription: 'Enter your username and we’ll send a verification code to your registered email.',
    resetUsername: 'Username',
    sendCode: 'Send verification code',
    sendingCode: 'Sending code…',
    back: 'Back to sign in',
    resetStepTitle: 'Check your email',
    resetStepDescription: 'Enter the code we sent and choose a new password.',
    codeLabel: 'Verification code',
    codePlaceholder: 'Enter your code',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    newPasswordPlaceholder: 'Create a new password',
    confirmPlaceholder: 'Re-enter your new password',
    passwordRequirements: 'Use 8+ characters, including at least 2 uppercase letters, 2 lowercase letters, 2 numbers, and 2 symbols. No spaces.',
    resetSubmit: 'Reset password',
    resetting: 'Updating password…',
    resend: 'Resend code',
    resendSuccess: 'A new code has been requested. Check your email.',
    codeSent: 'We sent a code to your registered email.',
    missingUsername: 'Enter your username to continue.',
    missingCode: 'Enter the verification code from your email.',
    passwordMismatch: 'The two passwords do not match.',
    passwordInvalid: 'Your new password does not meet the requirements shown below.',
    resetFailed: 'We couldn’t complete your request. Please check your details and try again.',
    resetSuccess: 'Password updated. Finishing your sign-in…',
    close: 'Close',
    understood: 'Okay',
    footer: 'Powered by Lenderblock Corporation',
    rights: 'All rights reserved.',
    security: 'Your account. Your opportunities.'
  },
  spanish: {
    languageSwitch: 'English',
    eyebrow: 'THE BLENDER PLATFORM',
    heroFirst: 'Una nueva forma de',
    heroAccent: 'avanzar.',
    heroDescription: 'Presta, solicita crédito y apuesta desde una plataforma de crédito conectada mediante blockchain.',
    heroLink: 'Conoce la plataforma',
    featureOne: 'Prestar',
    featureOneDescription: 'Pon a trabajar tu capital disponible.',
    featureTwo: 'Solicitar crédito',
    featureTwoDescription: 'Accede a crédito respaldado por garantía.',
    featureThree: 'Apostar',
    featureThreeDescription: 'Respalda oportunidades de crédito.',
    cardEyebrow: 'TU CUENTA',
    welcome: 'Te damos la bienvenida',
    welcomeDescription: 'Inicia sesión para acceder a tu panel Blender.',
    username: 'Usuario',
    password: 'Contraseña',
    usernamePlaceholder: 'Ingresa tu usuario',
    passwordPlaceholder: 'Ingresa tu contraseña',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    show: 'Mostrar',
    hide: 'Ocultar',
    forgot: '¿Olvidaste tu contraseña?',
    login: 'Iniciar sesión',
    loggingIn: 'Iniciando sesión…',
    newHere: '¿Aún no tienes una cuenta?',
    createAccount: 'Crear una cuenta',
    resetEyebrow: 'RECUPERACIÓN DE CUENTA',
    resetTitle: 'Restablece tu contraseña',
    resetDescription: 'Ingresa tu usuario y te enviaremos un código a tu correo registrado.',
    resetUsername: 'Usuario',
    sendCode: 'Enviar código de verificación',
    sendingCode: 'Enviando código…',
    back: 'Volver a iniciar sesión',
    resetStepTitle: 'Revisa tu correo',
    resetStepDescription: 'Ingresa el código enviado y elige una contraseña nueva.',
    codeLabel: 'Código de verificación',
    codePlaceholder: 'Ingresa tu código',
    newPassword: 'Contraseña nueva',
    confirmPassword: 'Confirma tu contraseña',
    newPasswordPlaceholder: 'Crea una contraseña nueva',
    confirmPlaceholder: 'Repite tu contraseña nueva',
    passwordRequirements: 'Usa 8 caracteres o más, con al menos 2 mayúsculas, 2 minúsculas, 2 números y 2 símbolos. Sin espacios.',
    resetSubmit: 'Restablecer contraseña',
    resetting: 'Actualizando contraseña…',
    resend: 'Reenviar código',
    resendSuccess: 'Solicitamos un nuevo código. Revisa tu correo.',
    codeSent: 'Enviamos un código a tu correo registrado.',
    missingUsername: 'Ingresa tu usuario para continuar.',
    missingCode: 'Ingresa el código de verificación de tu correo.',
    passwordMismatch: 'Las contraseñas no coinciden.',
    passwordInvalid: 'Tu contraseña no cumple los requisitos indicados.',
    resetFailed: 'No pudimos completar tu solicitud. Revisa tus datos e inténtalo otra vez.',
    resetSuccess: 'Contraseña actualizada. Estamos terminando de iniciar sesión…',
    close: 'Cerrar',
    understood: 'De acuerdo',
    footer: 'Desarrollada por Lenderblock Corporation',
    rights: 'Todos los derechos reservados.',
    security: 'Tu cuenta. Tus oportunidades.'
  }
};

const passwordMeetsRequirements = value => {
  const password = String(value || '');
  return password.length >= 8 &&
    (password.match(/[A-Z]/g) || []).length >= 2 &&
    (password.match(/[a-z]/g) || []).length >= 2 &&
    (password.match(/[0-9]/g) || []).length >= 2 &&
    (password.match(/[@#$%^&*()_+\-=\[\]{};!':"\\|,.<>\/?]/g) || []).length >= 2 &&
    !/\s/.test(password);
};

/**
 * Shared, responsive welcome experience.
 * All login and navigation state continues to live in Welcome.js (`that`).
 * Mobile and desktop intentionally share the same accessible markup.
 */
class WelcomeDesktopRender extends Component {
  state = {
    showPassword: false,
    showNewPassword: false,
    busyRecovery: false,
    recoveryMessage: '',
    recoveryError: ''
  };

  isSpanish = () => this.props.that.state.selectedLanguage === 'spanish';
  t = () => copy[this.isSpanish() ? 'spanish' : 'english'];

  changeLanguage = () => {
    const that = this.props.that;
    const next = this.isSpanish() ? 'english' : 'spanish';
    that.setState({ selectedLanguage: next });
    try { localStorage.setItem('primaryLanguage', next); } catch (error) { /* Storage can be disabled. */ }
  };

  backToLogin = () => {
    this.setState({ recoveryError: '', recoveryMessage: '', busyRecovery: false });
    this.props.that.setState({
      forgottenPasswordBool: false,
      newPasswordForgottenPasswordBool: false,
      finalPasswordResetReadyBool: false,
      authCodeOverlay: false,
      authCode: '',
      password1: '',
      password2: ''
    });
  };

  startRecovery = () => {
    this.setState({ recoveryError: '', recoveryMessage: '' });
    this.props.that.setState({
      forgottenPasswordBool: true,
      newPasswordForgottenPasswordBool: false,
      authCodeOverlay: false
    });
  };

  requestCode = async (event) => {
    if (event) event.preventDefault();
    if (this.state.busyRecovery) return;
    const that = this.props.that;
    const t = this.t();
    const username = String(that.state.usernameText || '').trim().toLowerCase();
    if (!username) {
      this.setState({ recoveryError: t.missingUsername });
      return;
    }

    this.setState({ busyRecovery: true, recoveryError: '', recoveryMessage: '' });
    try {
      // Public Cognito recovery endpoint: no authenticated API session is required.
      await trackPageRequest(Auth.forgotPassword(username));
      that.setState({
        usernameText: username,
        newPasswordForgottenPasswordBool: true,
        authCode: ''
      });
      this.setState({ recoveryMessage: t.codeSent });
      return true;
    } catch (error) {
      this.setState({ recoveryError: t.resetFailed });
      return false;
    } finally {
      this.setState({ busyRecovery: false });
    }
  };

  submitRecovery = async (event) => {
    if (event) event.preventDefault();
    if (this.state.busyRecovery) return;
    const that = this.props.that;
    const t = this.t();
    const username = String(that.state.usernameText || '').trim().toLowerCase();
    const code = String(that.state.authCode || '').trim();
    const password = String(that.state.password1 || '');
    if (!code) return this.setState({ recoveryError: t.missingCode });
    if (password !== String(that.state.password2 || '')) {
      return this.setState({ recoveryError: t.passwordMismatch });
    }
    if (!passwordMeetsRequirements(password)) {
      return this.setState({ recoveryError: t.passwordInvalid });
    }

    this.setState({ busyRecovery: true, recoveryError: '', recoveryMessage: '' });
    try {
      await trackPageRequest(Auth.forgotPasswordSubmit(username, code, password));
      // Retain the app's existing password-change / encrypted-key update workflow.
      this.setState({ recoveryMessage: t.resetSuccess });
      that.setState({
        forgottenPasswordBool: false,
        newPasswordForgottenPasswordBool: false,
        authCodeOverlay: false,
        authCode: '',
        password1: '',
        password2: ''
      }, () => that.updatePK(username, password));
    } catch (error) {
      this.setState({ recoveryError: t.resetFailed });
    } finally {
      this.setState({ busyRecovery: false });
    }
  };

  openRegister = () => {
    if (this.props.that.state.freezeButtonsBool) return;
    this.props.that.setState({ navigationDestinationObject: { navigationRoute: '/register' } });
  };

  render() {
    const that = this.props.that;
    const data = that.state;
    const t = this.t();
    const isRecovery = Boolean(data.forgottenPasswordBool);
    const codeSent = Boolean(data.newPasswordForgottenPasswordBool);
    const isBusy = Boolean(data.freezeButtonsBool || data.activityIndicator === true || this.state.busyRecovery);
    const theme = data.mode_light_dark === 'light' ? 'light' : 'dark';
    const year = new Date().getFullYear();

    return (
      <div className={`tbp-welcome tbp-welcome--desktop tbp-welcome--${theme}`}>
        <PageLoading theme={theme} language={data.selectedLanguage} busy={Boolean(data.freezeButtonsBool || data.activityIndicator === true)} />

        <div className="tbp-welcome__glow tbp-welcome__glow--a" aria-hidden="true" />
        <div className="tbp-welcome__glow tbp-welcome__glow--b" aria-hidden="true" />

        <div className="tbp-welcome__shell">
          <header className="tbp-welcome__header">
            <a className="tbp-welcome__brand" href={ABOUT_URL} target="_blank" rel="noopener noreferrer" aria-label="The Blender Platform">
              <img src={LOGO} alt="" className="tbp-welcome__logo" />
              <span className="tbp-welcome__brand-name">The Blender Platform</span>
            </a>
            <nav className="tbp-welcome__nav" aria-label="Welcome navigation">
              <a className="tbp-welcome__about" href={ABOUT_URL} target="_blank" rel="noopener noreferrer">{t.heroLink}<span aria-hidden="true"> ↗</span></a>
              {this.props.mobileLanguageSwitch ? (
                <PlatformLanguageButton selectedLanguage={data.selectedLanguage} onToggle={this.changeLanguage} />
              ) : (
                <button type="button" className="tbp-welcome__language" onClick={this.changeLanguage}>
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/><path d="M3 12h18M12 3c3 3 4.4 6 4.4 9S15 18 12 21c-3-3-4.4-6-4.4-9S9 6 12 3Z" stroke="currentColor" strokeWidth="1.5"/></svg>
                  {t.languageSwitch}
                </button>
              )}
            </nav>
          </header>

          <main className="tbp-welcome__main">
            <section className="tbp-welcome__story" aria-label="About The Blender Platform">
              <div className="tbp-welcome__eyebrow"><span className="tbp-welcome__eyebrow-dot" /> {t.eyebrow}</div>
              <h1 className="tbp-welcome__headline">{t.heroFirst}<br /><em>{t.heroAccent}</em></h1>
              <p className="tbp-welcome__intro">{t.heroDescription}</p>
              <a className="tbp-welcome__story-link" href={ABOUT_URL} target="_blank" rel="noopener noreferrer">
                {t.heroLink}<span aria-hidden="true" className="tbp-welcome__arrow">↗</span>
              </a>

              <div className="tbp-welcome__features" aria-label="Platform features">
                <div className="tbp-welcome__feature"><span className="tbp-welcome__feature-icon" aria-hidden="true">↗</span><div><strong>{t.featureOne}</strong><small>{t.featureOneDescription}</small></div></div>
                <div className="tbp-welcome__feature"><span className="tbp-welcome__feature-icon" aria-hidden="true">↔</span><div><strong>{t.featureTwo}</strong><small>{t.featureTwoDescription}</small></div></div>
                <div className="tbp-welcome__feature"><span className="tbp-welcome__feature-icon" aria-hidden="true">◇</span><div><strong>{t.featureThree}</strong><small>{t.featureThreeDescription}</small></div></div>
              </div>
            </section>

            <section className="tbp-welcome__account" aria-label={isRecovery ? t.resetTitle : t.welcome}>
              <div className="tbp-welcome__account-topline"><span /> <span /></div>
              <div className="tbp-welcome__account-content">
                <span className="tbp-welcome__card-kicker">{isRecovery ? t.resetEyebrow : t.cardEyebrow}</span>
                <h2>{isRecovery ? (codeSent ? t.resetStepTitle : t.resetTitle) : t.welcome}</h2>
                <p className="tbp-welcome__card-description">{isRecovery ? (codeSent ? t.resetStepDescription : t.resetDescription) : t.welcomeDescription}</p>

                {isRecovery ? (
                  <form className="tbp-welcome__form" onSubmit={codeSent ? this.submitRecovery : this.requestCode} noValidate>
                    {!codeSent ? (
                      <div className="tbp-welcome__field">
                        <label htmlFor="tbp-recovery-username">{t.resetUsername}</label>
                        <input id="tbp-recovery-username" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={data.usernameText || ''} placeholder={t.usernamePlaceholder} disabled={isBusy} onChange={event => that.setState({ usernameText: event.target.value })} />
                      </div>
                    ) : (
                      <>
                        <div className="tbp-welcome__recovery-target">@{String(data.usernameText || '').trim().toLowerCase()}</div>
                        <div className="tbp-welcome__field">
                          <label htmlFor="tbp-recovery-code">{t.codeLabel}</label>
                          <input id="tbp-recovery-code" type="text" inputMode="numeric" autoComplete="one-time-code" value={data.authCode || ''} placeholder={t.codePlaceholder} disabled={isBusy} onChange={event => that.setState({ authCode: event.target.value })} />
                        </div>
                        <div className="tbp-welcome__field">
                          <label htmlFor="tbp-new-password">{t.newPassword}</label>
                          <div className="tbp-welcome__password-wrap">
                            <input id="tbp-new-password" type={this.state.showNewPassword ? 'text' : 'password'} autoComplete="new-password" value={data.password1 || ''} placeholder={t.newPasswordPlaceholder} disabled={isBusy} onChange={event => that.setState({ password1: event.target.value })} />
                            <button type="button" className="tbp-welcome__reveal" aria-label={this.state.showNewPassword ? t.hidePassword : t.showPassword} onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}>{this.state.showNewPassword ? t.hide : t.show}</button>
                          </div>
                        </div>
                        <div className="tbp-welcome__field">
                          <label htmlFor="tbp-confirm-password">{t.confirmPassword}</label>
                          <input id="tbp-confirm-password" type={this.state.showNewPassword ? 'text' : 'password'} autoComplete="new-password" value={data.password2 || ''} placeholder={t.confirmPlaceholder} disabled={isBusy} onChange={event => that.setState({ password2: event.target.value })} />
                        </div>
                        <p className="tbp-welcome__requirements">{t.passwordRequirements}</p>
                      </>
                    )}
                    {this.state.recoveryError && <p className="tbp-welcome__form-error" role="alert">{this.state.recoveryError}</p>}
                    {this.state.recoveryMessage && <p className="tbp-welcome__form-success" role="status">{this.state.recoveryMessage}</p>}
                    <button type="submit" className="tbp-welcome__submit" disabled={isBusy}>
                      {this.state.busyRecovery ? (codeSent ? t.resetting : t.sendingCode) : (codeSent ? t.resetSubmit : t.sendCode)}<span aria-hidden="true">→</span>
                    </button>
                    {codeSent && <button type="button" className="tbp-welcome__text-action" disabled={isBusy} onClick={async () => { const sent = await this.requestCode(); if (sent) this.setState({ recoveryMessage: this.t().resendSuccess }); }}>{t.resend}</button>}
                    <button type="button" className="tbp-welcome__back" onClick={this.backToLogin} disabled={isBusy}><span aria-hidden="true">←</span> {t.back}</button>
                  </form>
                ) : (
                  <form className="tbp-welcome__form" onSubmit={event => { event.preventDefault(); if (!isBusy) that.loginUser(false); }}>
                    <div className="tbp-welcome__field">
                      <label htmlFor="tbp-login-username">{t.username}</label>
                      <input id="tbp-login-username" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={data.usernameText || ''} placeholder={t.usernamePlaceholder} disabled={isBusy} onChange={event => that.setState({ usernameText: event.target.value, failedLoginBool: false })} />
                    </div>
                    <div className="tbp-welcome__field">
                      <div className="tbp-welcome__field-head"><label htmlFor="tbp-login-password">{t.password}</label><button type="button" className="tbp-welcome__forgot" onClick={this.startRecovery} disabled={isBusy}>{t.forgot}</button></div>
                      <div className="tbp-welcome__password-wrap">
                        <input id="tbp-login-password" type={this.state.showPassword ? 'text' : 'password'} autoComplete="current-password" value={data.passwordText || ''} placeholder={t.passwordPlaceholder} disabled={isBusy} onChange={event => that.setState({ passwordText: event.target.value, failedLoginBool: false })} />
                        <button type="button" className="tbp-welcome__reveal" aria-label={this.state.showPassword ? t.hidePassword : t.showPassword} onClick={() => this.setState({ showPassword: !this.state.showPassword })}>{this.state.showPassword ? t.hide : t.show}</button>
                      </div>
                    </div>
                    <button type="submit" className="tbp-welcome__submit" disabled={isBusy}><span className="tbp-welcome__submit-label">{isBusy ? t.loggingIn : t.login}</span><span className="tbp-welcome__submit-arrow" aria-hidden="true">→</span></button>
                    <div className="tbp-welcome__separator"><span /></div>
                    <div className="tbp-welcome__join"><span>{t.newHere}</span><button type="button" onClick={this.openRegister} disabled={isBusy}>{t.createAccount} <span aria-hidden="true">↗</span></button></div>
                  </form>
                )}
              </div>
              <div className="tbp-welcome__card-foot"><span className="tbp-welcome__lock" aria-hidden="true">◇</span>{t.security}</div>
            </section>
          </main>

          <footer className="tbp-welcome__footer"><span>© {year} The Blender Platform. {t.rights}</span><span>{t.footer}</span></footer>
        </div>

        {Boolean(data.errorTags) && (
          <div className="tbp-welcome__dialog-backdrop" role="presentation">
            <div className="tbp-welcome__dialog" role="alertdialog" aria-modal="true" aria-labelledby="tbp-welcome-error-title" aria-describedby="tbp-welcome-error-message">
              <div className="tbp-welcome__dialog-header"><img src={LOGO} alt="" /><strong>The Blender Platform</strong><button type="button" className="tbp-welcome__dialog-close" aria-label={t.close} onClick={() => that.setState({ errorTags: null })}>×</button></div>
              <h2 id="tbp-welcome-error-title">{this.isSpanish() ? 'No pudimos continuar' : 'We couldn’t continue'}</h2>
              <div id="tbp-welcome-error-message" className="tbp-welcome__dialog-message">{data.errorTags}</div>
              <button type="button" className="tbp-welcome__submit" onClick={() => that.setState({ errorTags: null, successfulDepositOverlay: false })}>{t.understood}</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default WelcomeDesktopRender;
